export type SessionPingDeviceInfoType = {
    mobile_app: boolean;
    device_information: string | null;
};

const isMobileAppType = (value: string | null | undefined): boolean => {
    if (value === null || value === undefined) {
        return false;
    }

    const lower = value.toLowerCase();
    return lower.includes('ios-app') || lower.includes('android-app');
};

const readWindowString = (key: 'device' | 'deviceVersion'): string | null => {
    if (typeof window === 'undefined') {
        return null;
    }

    const windowWithDevice = window as Window & {
        device?: string | null;
        deviceVersion?: string | null;
    };
    const value = key === 'device' ? windowWithDevice.device : windowWithDevice.deviceVersion;
    return typeof value === 'string' ? value : null;
};

const formatDeviceInformation = (device: string | null, deviceVersion: string | null): string | null => {
    if (device !== null && deviceVersion !== null) {
        return `${device}/${deviceVersion}`;
    }

    if (device !== null) {
        return device;
    }

    if (deviceVersion !== null) {
        return deviceVersion;
    }

    if (typeof navigator !== 'undefined') {
        return navigator.userAgent;
    }

    return null;
};

export const getSessionPingDeviceInfo = (params: {
    mobileWrapperType: string | null | undefined;
    mobileWrapperVersion: string | null | undefined;
    browserType?: string | null | undefined;
}): SessionPingDeviceInfoType => {
    const windowDevice = readWindowString('device');
    const windowDeviceVersion = readWindowString('deviceVersion');
    const device = params.mobileWrapperType ?? windowDevice;
    const deviceVersion = params.mobileWrapperVersion ?? windowDeviceVersion;
    const isMobileApp = isMobileAppType(params.mobileWrapperType) || isMobileAppType(windowDevice);

    return {
        mobile_app: isMobileApp,
        device_information: formatDeviceInformation(
            device ?? params.browserType ?? null,
            isMobileApp ? deviceVersion : null
        ),
    };
};
